// Daily Free Activity public API client (no auth required).
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const daily = axios.create({
  baseURL: `${API}/daily`,
});

export const fetchCurrentDaily = async () => (await daily.get("/current")).data;

export const fetchDailyList = async () => (await daily.get("/list")).data;

export const fetchDailyListFull = async () =>
  (await daily.get("/list", { params: { full: true } })).data;

export const fetchDailyActivity = async (day) =>
  (await daily.get(`/${day}`)).data;

export const dailyWorksheetPdfUrl = (day) => `${API}/daily/${day}/worksheet.pdf`;
